module.exports = __webpack_public_path__ + "static/media/silicon-farm-poster-desktop.8596b814.jpg";